<template>
  <main>
    <AntecedenteComponent v-model="grupos" />
  </main>
</template>

<script>
import usuarioService from "../../../services/usuarioService";
import grupoAntecedenteService from "../../../services/grupoAntecedenteService";
import antecedenteUsuarioService from "../../../services/antecedenteUsuarioService";
import { isEmpty } from "lodash";
import embarazoService from "../../../services/embarazoService";
import AntecedenteComponent from "../../../components/antecedentes/AntecedenteComponent.vue";

export default {
  name: "AntecedentViewComponent",
  components: {
    AntecedenteComponent,
  },
  props: ["idUsuario"],
  data() {
    return {
      usuario: {},
      grupos: [],
      embarazo_actual: {},
    };
  },
  methods: {
    async getAntecedentes() {
      const filter = {
        sexo: this.usuario.sexo,
        fecha_nacimiento: this.usuario.fecha_nacimiento,
        ...(!isEmpty(this.embarazo_actual) &&
        this.embarazo_actual.activo === "S"
          ? { gestante: "S" }
          : {}),
      };

      const response = await grupoAntecedenteService.index({
        params: filter,
      });

      const antecedentes_usuario = await antecedenteUsuarioService.index(
        this.usuario.id
      );

      this.grupos = response.data
        .filter((x) => x.antecedentes.length > 0)
        .map((x) => {
          x.antecedentes.forEach((y, i) => {
            const indice = antecedentes_usuario.data.findIndex(
              (a) => a.id_antecedente === y.id
            );
            const userAnt = indice !== -1 ? antecedentes_usuario.data[indice] : {};

            let userDetalles = [];
            if (userAnt) {
              if (Array.isArray(userAnt.condiciones)) {
                userDetalles.push(...userAnt.condiciones.map(d => ({ ...d, tipo_detalle: 'CONDITION' })));
              }
              if (Array.isArray(userAnt.alergias)) {
                userDetalles.push(...userAnt.alergias.map(d => ({ ...d, tipo_detalle: 'ALLERGY' })));
              }
              if (Array.isArray(userAnt.medicamentos)) {
                userDetalles.push(...userAnt.medicamentos.map(d => ({ ...d, tipo_detalle: 'MEDICATION' })));
              }
              if (Array.isArray(userAnt.familiares)) {
                userDetalles.push(...userAnt.familiares.map(d => ({ ...d, tipo_detalle: 'FAMILY_HISTORY' })));
              }
              if (Array.isArray(userAnt.detalles)) {
                userDetalles.push(...userAnt.detalles);
              }
            }

            x.antecedentes[i]["antecedente_usuario"] = {
              id: userAnt.id || 0,
              id_usuario: this.usuario.id,
              id_antecedente: y.id,
              valor: userAnt.valor || "",
              detalles: userDetalles,
            };
          });
          return {
            ...x,
          };
        });
    },
    async cargarUsuario() {
      const response = await usuarioService.show(this.idUsuario);
      this.usuario = response.data;

      const res_embarazo_actual = await embarazoService.showByLast(
        this.idUsuario
      );
      this.embarazo_actual = res_embarazo_actual.data;
    },
    returnAntecedent() {
      let antecedentes_usuario = [];
      this.grupos.forEach((x) => {
        x.antecedentes.forEach((y) => {
          if (y.antecedente_usuario.valor !== "") {
            antecedentes_usuario.push({ ...y.antecedente_usuario });
          }
        });
      });

      return antecedentes_usuario;
    },
  },
  async mounted() {
    if (this.idUsuario) {
      try {
        this.LoaderSpinnerShow();
        await this.cargarUsuario();
        await this.getAntecedentes();
        this.LoaderSpinnerHide();
      } catch (error) {
        this.LoaderSpinnerHide();
        console.error("Error al cargar datos:", error);
      } 
    }
  },
  watch: {
    idUsuario: async function () {
      await this.cargarUsuario();
      await this.getAntecedentes();
    },
  },
};
</script>
